import React from 'react';
import { Button, Container, HeaderSection, List, ListItem, Radio } from '@groupelacentrale/contact-storybook';
import './VerticalChoice.scss';

interface Props {
  verticalChoice: string;
  verticalChoices: { value: string; label: string }[];
  isSubmitting: boolean;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

export const VerticalChoiceFormView: React.FC<Props> = ({
  verticalChoice,
  verticalChoices,
  isSubmitting,
  handleChange,
  handleSubmit,
}) => {
  return (
    <Container shadowed paddings="mediumP" backgroundColor="bgWhite">
      <form className="vertical-choice" onSubmit={handleSubmit}>
        <HeaderSection noUnderline>Choisissez le type de véhicule</HeaderSection>
        <List>
          {verticalChoices.map(el => (
            <ListItem key={el.value}>
              <Radio
                name="verticalChoice"
                theme="primary"
                value={el.value}
                label={el.label}
                onChange={handleChange}
                checked={verticalChoice === el.value}
              />
            </ListItem>
          ))}
        </List>
        <Button fluid label="Continuer" type="submit" theme="primary" disabled={isSubmitting} loading={isSubmitting} />
      </form>
    </Container>
  );
};
